<nav aria-label="Page navigation example">
  <ul class="pagination mb-0 center">
    <li class="page-item">
      <button class="btn p-0" (click)="previuspage()" [disabled]="active === 1">
        <a class="page-link page-link-none-bg" aria-label="Previous">
          <em class="fa fa-caret-left"></em>
        </a>
      </button>
    </li>
    <li
      class="page-item new-page-item"
      *ngFor="let item of default; let i = index"
      (click)="getIndex(item)"
      [ngClass]="{ active: item === active, 'page-item-mobile-hidden': isHiddenOnMobile(i) }"
    >
      <a class="page-link">{{ item }}</a>
    </li>
    <li class="page-item">
      <button class="btn p-0" [disabled]="validateTotal(total)" (click)="nextPage()">
        <a class="page-link page-link-none-bg" aria-label="Next">
          <em class="fa fa-caret-right"></em>
        </a>
      </button>
    </li>
  </ul>
</nav>
